import {
	Box,
	Button,
	Divider,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Autocomplete,
	CircularProgress,
	Typography,
} from "@mui/material";
import TvIcon from "@mui/icons-material/Tv";
import React from "react";
import { durationList, sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import {
	getChartDataForCustomer,
	getChartDataForData,
	getCustomers,
	getScenariosForCustomer,
	getSkuPg,
	getSkuPgForCustomer,
	getCustomersForCustomer,
	setState,
} from "../analyzeSlice";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";
import { ElectricScooterOutlined } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroller";
import { FixedSizeList as List } from 'react-window';

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;



export default function Form() {

	const [alert, setAlert] = useState({
		alertSeverity: "",
		alertDisplay: false,
		alertMessage: ""
	});

	const [countryCust, setCountryCust] = useState("");
	const [scenarioCust, setScenarioCust] = useState("");
	//const [scenarioCust, setScenarioCust] = useState(scenariosCust?.[0]?.scenarioID || '');
	const [skuPgCust, setSKuPgCust] = useState("");
	const [customerCust, setCustomerCust] = useState("");

	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const loginState = useSelector((store) => store.login);

	const {
		countries,
		selectedCountry,
		selectedCountryID,

		isActiveScenario,

		selectedAnalysisTypeID,

		scenariosCust,
		selectedScenarioName,
		selectedScenarioID,

		skuPgsCust,
		selectedSkuPgName,
		selectedSkuPgID,

		customersCust,
		selectedCustomerName,
		selectedCustomerID,

		duration,
		//loading,
	} = state;

	const {
		globalSelectedCountryName,
		globalSelectedCountryID,
	} = loginState

	const itemsPerPage = 200;
	const [hasMore, setHasMore] = useState(true);
	const [records, setrecords] = useState(itemsPerPage);

	const [open, setOpen] = useState(false);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);

	const loadMore = () => {
		if (records === customersCust.length) {
			setHasMore(false);
		} else {
			setTimeout(() => {
				setrecords(records + itemsPerPage);
			}, 2000);
		}
	};


	useEffect(() => {
		let active = true;
		if (loading && customersCust.length > 0) {
			(async () => {
				// Simulate a network request
				await new Promise((resolve) => setTimeout(resolve, 1000));
				// Replace the above with your actual data fetching logic

				if (active) {
					setOptions([{ customerName: "All" }, ...customersCust]);
					setLoading(false);
				}
			})();
		}
		else {
			active = false
		}
	}, [loading, customersCust]);


	useEffect(() => {
		if (!open) {
			setOptions([]);
		} else {
			setLoading(true);
		}
	}, [open]);

	let skuPgsArr = []
	if (skuPgsCust?.length > 0) {
		skuPgsArr = skuPgsCust?.filter(item => item.packGroupOrSKUName !== "All");
	}


	useEffect(() => {
		dispatch(setState("selectedCountry", ""));
		dispatch(setState("selectedCountryID", ""));

		dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("selectedScenarioID", ""));
		dispatch(setState("selectedSkuPgName", ""));
		dispatch(setState("selectedCustomerName", ""));
		dispatch(setState("duration", null));
		dispatch(setState("clearAnalyzeCustomer", false));

		dispatch(setState("scenariosCust", []));
		dispatch(setState("skuPgsCust", []));
		dispatch(setState("customersCust", []));
	}, [])

	console.log(selectedScenarioName);

	useEffect(() => {
		if (countryCust !== "") {
			getScenariosForCountry();
		}
	}, [countryCust]);

	useEffect(() => {
		if (scenarioCust !== "") {
			getSkuPgForScenario();
			getCustomersForScenario();
		}
	}, [scenarioCust]);

	useEffect(() => {
		if(scenariosCust.length>0){
		let id =scenariosCust?.[0]?.scenarioID;
		const name = scenariosCust.find(
			(scenario) => scenario.scenarioID === id
		).scenarioName;
		dispatch(setState("selectedScenarioName", name));
		dispatch(setState("selectedScenarioID", id));

		dispatch(setState("clearAnalyzeCustomer", false));

		setScenarioCust(id);
		}
	}, [scenariosCust]);	

	useEffect(() => {
		if(skuPgsCust.length>0){
		let id = 0;
		const name = skuPgsCust.find(
			(sku) => sku.packGroupOrSKUID === id
		).packGroupOrSKUName;
		dispatch(setState("selectedSkuPgName", name));
		dispatch(setState("selectedSkuPgID", id));

		setSKuPgCust(name);
		}
	}, [skuPgsCust]);	
	
	
	useEffect(() => {
		if(customersCust.length>0){
			console.log("1customersCust",customersCust);
			dispatch(setState("selectedCustomerName", "All"));
			dispatch(setState("selectedCustomerID", 0));
			setCustomerCust("All");			
		}
	}, [customersCust]);		



	const clearValuesForCountry = () => {
		dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("selectedScenarioID", ""));
		dispatch(setState("selectedSkuPgName", ""));
		dispatch(setState("selectedCustomerName", ""));

		//dispatch(setState("duration", ""));

		dispatch(setState("scenariosCust", []));
		dispatch(setState("skuPgsCust", []));
		dispatch(setState("customersCust", []));
		setOptions([]);
		setCustomerCust("");
	}

	const clearValuesForScenario = () => {
		dispatch(setState("selectedSkuPgName", ""));
		dispatch(setState("selectedCustomerName", ""));

		dispatch(setState("skuPgsCust", []));
		dispatch(setState("customersCust", []));

		//dispatch(setState("duration", ""));
		
		setOptions([]);
		setCustomerCust("");
		setSKuPgCust("");

	}

	function setCountry(event) {
		const name = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === name
		).countryID;

		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));

		setCountryCust(name);

		clearValuesForCountry();
	}

	useEffect(() => {
		if (globalSelectedCountryID !== null) {
			dispatch(setState("selectedCountryID", globalSelectedCountryID));
		}
	}, [globalSelectedCountryID])

	useEffect(() => {
		if (globalSelectedCountryName !== null) {
			dispatch(setState("selectedCountry", globalSelectedCountryName));
			setCountryCust(globalSelectedCountryName);
		}
	}, [globalSelectedCountryName])

	function getScenariosForCountry() {
		const countryID = selectedCountryID;
		const activeScenario = isActiveScenario;
		const analyisID = selectedAnalysisTypeID;
		const obj = {
			countryID,
			activeScenario,
			analyisID,
		};
		dispatch(getScenariosForCustomer(obj));
		dispatch(setState("clearAnalyzeCustomer", false));
	}

	function getCustomersForScenario() {
		console.log("Calling getCustomersForScenario");
		const obj = {
			scenarioID: selectedScenarioID,
		};
		dispatch(getCustomersForCustomer(obj));
	}

	function setScenario(event) {
		const id = event.target.value;
		const name = scenariosCust.find(
			(scenario) => scenario.scenarioID === id
		).scenarioName;
		dispatch(setState("selectedScenarioName", name));
		dispatch(setState("selectedScenarioID", id));

		dispatch(setState("clearAnalyzeCustomer", false));

		setScenarioCust(id);

		clearValuesForScenario();
	}

	function getSkuPgForScenario() {
		const scenarioID = selectedScenarioID;
		const obj = {
			scenarioID,
		};
		dispatch(getSkuPgForCustomer(obj));
	}

	function setSkuPg(event) {
		const name = event.target.value;
		let id = 0;
		console.log(skuPgsArr)
		if (name !== "All") {
			id = skuPgsArr.find(
				(skuPg) => skuPg.packGroupOrSKUName === name
			).packGroupOrSKUID;
			console.log(id)
		}
		dispatch(setState("selectedSkuPgName", name));
		dispatch(setState("selectedSkuPgID", id));

		setSKuPgCust(name);
	}

	function setCustomer(event, value) {
		//const name = event.target.value;
		const name = value;
		console.log(value);
		let id = 0;
		if (name !== "All") {
			id = customersCust?.find(
				(customer) => customer.customerName === name
			)?.customerID;
		}
		dispatch(setState("selectedCustomerName", name));
		dispatch(setState("selectedCustomerID", id));

		setCustomerCust(name);
	}

	function setDuration(event) {
		const d = event.target.value;
		if (d) {

		}
		dispatch(setState("duration", d));
	}

	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `Please select the ${severityType}`
		});

		setTimeout(() => {
			clearAlert();
		}, [2000])

	}

	const clearAlert = () => {
		setAlert({
			"alertSeverity": "",
			"alertDisplay": false,
			"alertMessage": ``
		});
	}



	// useEffect(() => {
	// 	//Check if any of the dropdown are false and then set alertDisplay to false
	// 	const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

	// 	if (isAnyKeyValueFalse(validate)) {
	// 		setAlert({ ...Alert, alertDisplay: false });
	// 	}
	// }, [validate])

	function handleDisplay() {
		if (selectedCountry === null || selectedCountry === "") {
			displayAlert("Country");
			return;
		}
		if (selectedScenarioName === null || selectedScenarioName === "") {
			displayAlert("Scenario");
			return;
		}
		if (selectedSkuPgName === null || selectedSkuPgName === "") {
			displayAlert("SKU / PG");
			return;
		}
		if (selectedCustomerName === null || selectedCustomerName === "") {
			displayAlert("Customer");
			return;
		}
		if (duration === null || duration === "") {
			displayAlert("Duration");
			return;
		}

		const scenarioID = selectedScenarioID;
		const productID = selectedSkuPgID;
		const customerID = selectedCustomerID;
		const obj = {
			scenarioID,
			customerID,
			productID,
			duration,
		};

		dispatch(setState("clearAnalyzeCustomer", true));

		dispatch(getChartDataForCustomer(obj));
	}


	// A function to render the menu items using react-window
	const MenuList = React.forwardRef(function MenuList(props, ref) {
		const { children, ...other } = props;
		const [itemData, setItemData] = React.useState([]);
		const itemSize = 48; // or your custom size

		React.useEffect(() => {
			setItemData(React.Children.toArray(children));
		}, [children]);

		return (
			<List
				height={250} // Adjust based on your needs
				width="80%"
				itemSize={() => itemSize}
				itemCount={itemData.length}
				itemData={itemData}
				{...other}
				ref={ref}
			>
				{({ data, index, style }) => (
					<div style={style}>
						{data[index]}
					</div>
				)}
			</List>
		);
	});

	// Your main component
	function VirtualizedSelect({ customersCust }) {
		const [customer, setCustomer] = React.useState('');

		return (
			<FormControl fullWidth>
				<InputLabel id="virtualized-select-label">Customer</InputLabel>
				<Select
					labelId="virtualized-select-label"
					id="virtualized-select"
					value={customer}
					onChange={(event) => setCustomer(event.target.value)}
					MenuProps={{
						PaperProps: {
							style: {
								maxHeight: 250, // Adjust based on your needs
							},
						},
						anchorOrigin: {
							vertical: 'bottom',
							horizontal: 'left',
						},
						transformOrigin: {
							vertical: 'top',
							horizontal: 'left',
						},
						getContentAnchorEl: null,
						children: (
							<MenuList>
								{customersCust.map((customer) => (
									<MenuItem key={customer.customerID} value={customer.customerName}>
										{customer.customerName}
									</MenuItem>
								))}
							</MenuList>
						),
					}}
				>
					{customersCust.map((customer) => (
						<MenuItem key={customer.customerID} value={customer.customerName}>
							{customer.customerName}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		);
	}

	console.log(customersCust);

	return (	
		<Box sx={{ mt: 3 }}>
			<Grid container columns={12} spacing={2}>
				<Grid item sm={6} md={4} lg={2}>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={countryCust}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={6} md={4} lg={2}>
					<FormControl>
						<InputLabel>Scenario</InputLabel>
						<Select
							value={scenarioCust}
							label="Scenario"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setScenario}
						>
							{scenariosCust?.map((scenario, index) => {
								return (
									<MenuItem key={index} value={scenario.scenarioID}>
										{scenario.scenarioName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={6} md={4} lg={2}>
					<FormControl>
						<InputLabel>Product</InputLabel>
						<Select
							value={skuPgCust}
							label="Product"
							sx={{
								height: selectHeight,
								color: "black.main",
								mt: 1,
							}}
							onChange={setSkuPg}
						>
							{skuPgsArr.length > 0 ? <MenuItem value="All">All</MenuItem> : null}
							{skuPgsArr?.map((skuPg, index) => {
								return (
									<MenuItem
										key={index}
										value={skuPg.packGroupOrSKUName}
									>
										{skuPg.packGroupOrSKUName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={6} md={4} lg={2}>
					{/* <InfiniteScroll
						pageStart={0}
						loadMore={loadMore}
						hasMore={hasMore}
						useWindow={false}
					> */}

					{/* <VirtualizedAutocomplete customersCust={largeDataSet} /> */}
					{/* <FormControl>
							<InputLabel>Customer</InputLabel>
							<Select
								value={customerCust}
								label="Customer"
								sx={{
									height: selectHeight, width: selectWidth,
									color: "black.main",
									mt: 1,
								}}
								onChange={setCustomer}
							>
								{customersCust.length > 0 ? <MenuItem value="All">All</MenuItem> : null}
								{customersCust?.map((customer, index) => {
									return (
										<MenuItem key={index} value={customer.customerName}>
											{customer.customerName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl> */}
					{/* <VirtualizedSelect customersCust={customersCust} /> */}

					<Autocomplete
						id="asynchronous-autocomplete"
						//style={{ width: 500 }}
						sx={{'& .MuiInputBase-root':
						{fontFamily:'Montserrat,Helvetica,Arial,sans-serif',
						fontWeight: 500,
						padding: '1px 4px',
					},
					// 	'& .MuiAutocomplete-listbox':
					// 	{fontFamily:'Montserrat,Helvetica,Arial,sans-serif',
					// 	fontWeight: 500,
					// 	color: 'green',	
					
					// },
					// '& .MuiAutocomplete-option':{
					// 	fontFamily:'Montserrat,Helvetica,Arial,sans-serif!important',
					// 	fontWeight: 500,
					// 	color: 'green',			
					// },
						
					}}						
						open={open}
						onOpen={() => {
							setOpen(true);
						}}
						onClose={() => {
							setOpen(false);
						}}
						getOptionLabel={(option) => option}
						options={options.map(x=>x.customerName) }
						value = {customerCust}
						loading={loading}
						onChange={setCustomer}
						renderInput={(params) => (
							<TextField
								{...params}
								label="Customer"
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<React.Fragment>
											{loading ? <CircularProgress color="inherit" size={20} /> : null}
											{params.InputProps.endAdornment}
										</React.Fragment>
									),
								}}

							/>
						)}
						renderOption={(props,option)=>(
						<li{...props}>
						<Typography style={{fontFamily: 'Montserrat,Helvetica,Arial,sans-serif',fontWeight:"500"}}>{option}</Typography>
						</li>
						)}
					/>

					{/* </InfiniteScroll> */}
				</Grid>

				<Grid item sm={6} md={4} lg={2}>
					<FormControl>
						<InputLabel>Duration</InputLabel>
						<Select
							value={duration}
							label="Duration"
							sx={{
								height: selectHeight,
								color: "black.main",
								mt: 1,
							}}
							onChange={setDuration}
						>
							{durationList.map((duration, index) => {
								return (
									<MenuItem key={index} value={duration.value}>
										{duration.label}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={6} md={4} lg={1}>
					<Button
						startIcon={<TvIcon />}
						sx={{
							bgcolor: "darkBlue.light",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							//mt: 1,
							"&:hover": {
								bgcolor: "darkBlue.main",
							},
						}}
						onClick={handleDisplay}
					>
						Display
					</Button>
				</Grid>
			</Grid>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
			<Divider sx={{ mt: 3 }} />
		</Box>
	);
}
